export class Populations {
  public static Default = 'Default';
  public static Employees = 'Employees';
  public static STH = 'STH';
  public static Kids = 'Kids';
}
